import React from 'react';
import './styles.css';

function CardImage(props) {
    const { images: { image_highlight = '' }} = props;
  return (    
    <div className={'card card-image'}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          {image_highlight !== '' &&
          <div
            className='card-cover-image'
            style={{ backgroundImage: `url(${image_highlight})` }}
          />
          }
        </div>
      </div>
    </div>
  );
}

export default CardImage;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardImage/index.js